<template>
<div>
<p>Zlecenia dla {{users.name}}::</p>
 <v-list three-line>
          <template v-for="(item, index) in items">
<router-link :to="{ path: '/zlecenia/'+item.id}" >
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
            <v-list-tile v-else :key="item.nazwa" avatar @click="">
              <v-list-tile-avatar size="100" >
               {{item.data_zlecenia}}
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.nazwa"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.planowana_data_rozpoczecia"></v-list-tile-sub-title>
               
                
              </v-list-tile-content>
                <v-list-tile-action>
              <v-icon :color="item.czy_zrealizowane ? 'grey' : 'red'">chat_bubble</v-icon>
            </v-list-tile-action>
            </v-list-tile>
</router-link>
          </template>
        </v-list>


<v-btn @click="refresh">Odświerz</v-btn>
 

  <!-- <ul v-if="errors && errors.length">
    <li v-for="error of errors">
     1: {{error.stack}}
    </li>
  </ul> -->
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      items: [],
      errors: [],
      users:[]
    }
  },

  // Fetches posts when the component is created.
  created() {
 
      var token = localStorage.getItem('token')
      // console.log(token )
      //

      axios.get(`api/users?token=`+token
       )
    .then(response => {
      // JSON responses are automatically parsed.
      // this.users = response.data
      //  console.log(token);
      //  console.log(response.data);
    })
     .catch(e => {
      this.errors.push(e)
      
    })
    console.log('teraz zlecenia')
 axios.get('api/mojezlecenia/'+this.users.id+'?token='+token
       )
    .then(response => {
     
     
      //  console.log(response.data);
    })
     .catch(e => {
      this.errors.push(e)
      
    })

 console.log('koniec teraz zlecenia')


      //

       if (token == null) {
        this.$router.push('/')
         
       }
       else {
             var wm = this;
       axios.get(`api/users?token=`+token
       )
    .then(response => {
      // JSON responses are automatically parsed.
       wm.users = response.data
      //  console.log(token);
       
      //  console.log(wm.users.id);
      
    axios.get('api/mojezlecenia/'+wm.users.id+'?token='+token
    )
    .then(response => {
      // JSON responses are automatically parsed.
   
        
      wm.items = response.data
      // console.log(response.data)

    })
    .catch(e => {
      wm.errors.push(e)
      
    })
 
    })
    .catch(e => {
      // console.log(wz.errors)
      wm.errors.push(e)
      // console.log(wz.errors)
    })
       }
  },
  methods: {
    refresh() {
      var token = localStorage.getItem('token')
      var wm = this;
       axios.get(`api/users?token=`+token)
    .then(response => {
      // JSON responses are automatically parsed.
       wm.users = response.data
      //  console.log(token);
       
      // console.log(wm.users.id);
      
    axios.get('api/mojezlecenia/'+wm.users.id+'?token='+token)
    .then(response => {
      // JSON responses are automatically parsed.
  //  console.log('dasdasdasdasda')
  //       console.log(response.data)
      wm.items = response.data

    })
    .catch(e => {
      wm.errors.push(e)
      
    })
 
    })
    .catch(e => {
      wm.errors.push(e)
    })
    }
  }
}
</script>
<style scoped>
.list a {
    text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// src/components/MojeZlecenia.vue